import { Text, Tooltip } from '@elkaso-app/web-design';
import React from 'react';

export interface TradeLicenseNameCellProps {
  tradeLicenseName: string;
}

export const TradeLicenseNameCell: React.FC<TradeLicenseNameCellProps> = ({ tradeLicenseName }) => (
  <div style={{ height: '80px', display: 'flex', alignItems: 'center', padding: '8px 0', maxWidth: '100%' }}>
    <Tooltip label={tradeLicenseName} isDisabled={tradeLicenseName?.length <= 30}>
      <Text
        fontWeight='medium'
        fontSize='md'
        color='blue.700'
        lineHeight='1.2'
        maxW='100%'
        wordBreak='break-word'
        whiteSpace='normal'
        noOfLines={2}>
        {tradeLicenseName || 'N/A'}
      </Text>
    </Tooltip>
  </div>
);
